export default __webpack_public_path__ + "static/media/bell_notification.14fea01e.svg";